import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import noop from 'lodash/noop';

import useTimeout from 'Hooks/useTimeout';

import { getIsIncentiveEligibilityCheckComplete } from 'Store/incentives/selectors';
import { openModal } from 'Store/modals/actions';
import { MODAL_INCENTIVE_REDEMPTION } from 'Store/modals/constants';
import { getIncentivePromoCode, getShouldShowPromoPage } from 'Store/user/selectors';

import { MODAL_OPEN_DELAY } from '../constants';

const useIncentiveModal = ({
  modalProps,
  postCheckCompleteAction = noop,
}: {
  modalProps?: Record<string, any>;
  postCheckCompleteAction?: () => void;
} = {}) => {
  const dispatch = useDispatch();
  const eligibilityCheckComplete = useSelector(getIsIncentiveEligibilityCheckComplete);
  const promoCode = useSelector(getIncentivePromoCode);
  const shouldShowPromoPage = useSelector(getShouldShowPromoPage);

  const incentiveModalTimeout = useTimeout(() => {
    dispatch(openModal(MODAL_INCENTIVE_REDEMPTION, modalProps));
  }, MODAL_OPEN_DELAY);

  useEffect(() => {
    if (shouldShowPromoPage || (promoCode && !eligibilityCheckComplete)) {
      incentiveModalTimeout.start();
    }
    return () => {
      incentiveModalTimeout.clear();
    };
  }, [shouldShowPromoPage, promoCode, eligibilityCheckComplete, incentiveModalTimeout]);

  useEffect(() => {
    if (eligibilityCheckComplete) {
      postCheckCompleteAction();
    }
  }, [eligibilityCheckComplete, postCheckCompleteAction]);

  return {
    eligibilityCheckComplete,
  };
};

export default useIncentiveModal;
